import { environment, getSentryConfig } from '@environments';
import Vue from 'vue';
import adapter from 'webrtc-adapter';
import VueSignaturePad from 'vue-signature-pad';
import { Loader } from '@googlemaps/js-api-loader';
import VueCookies from 'vue-cookies';
import EnvironmentPlugin from '@/plugins/environment';
import { initializeSentry } from '@/common/sentry';

import store from '@/store';
import router from '@/router';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify';
import moment from 'moment';

import api from '@/config/api';
import prototypes from '@/config/prototypes';
import filters from '@/common/filters';
import directives from '@/common/directives';
import validations from '@/common/validations';

import '@/common/sockets';
import '@/config/globalComponents';

import App from './App.vue';

import './assets/style/main.scss';

Vue.use(VueCookies);
Vue.use(VueSignaturePad);
Vue.use(EnvironmentPlugin);
// Add app filters
window.adapter = adapter;

api(Vue);
filters(Vue);
prototypes(Vue);
directives(Vue);
validations(Vue);

Vue.config.productionTip = false;

// fix numeric values in moment arabic localization
moment.defineLocale('ar', {
  parentLocale: 'ar',
  preparse(string) { return string; },
  postformat(string) { return string; },
});

// google maps geoposotion detection
const loader = new Loader({
  apiKey: environment.VUE_APP_GOOGLE_MAPS_KEY,
  version: '3',
  libraries: ['places'],
});

// fix numeric values in Moment Arabic localization
moment.defineLocale('ar', {
  parentLocale: 'ar',
  preparse(string) { return string; },
  postformat(string) { return string; },
});

loader.load();

initializeSentry({
  Vue,
  ...getSentryConfig(),
});

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
